import React, {
  forwardRef,
  DetailedHTMLProps,
  TextareaHTMLAttributes,
} from "react";
import classNames from "classnames";

export type InputSize = "medium" | "large";
export type InputType = "text" | "email" | "password" | "number";

export type InputProps = {
  id: string;
  name: string;
  label?: string;
  type?: InputType;
  rows?: number;
  size?: InputSize;
  className?: string;
  placeholder?: string;
  onFocus?: () => void;
  onChange?: (data: any) => any;
} & Omit<
  DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >,
  "size"
>;

// const sizeMap: { [key in InputSize]: string } = {
//   medium: "p-3 text-base",
//   large: "p-4 text-base",
// };

const TextAreaInput = forwardRef<HTMLTextAreaElement, InputProps>(
  (
    {
      id,
      name,
      label,
      // size = "medium",
      className = "",
      placeholder,
      rows,
      onFocus,
      onChange,
      ...props
    },
    ref
  ): JSX.Element => {
    return (
      <React.Fragment>
        {label && (
          <label htmlFor={id} className="form-label">
            {label}
          </label>
        )}
        <div>
          <textarea
            id={id}
            ref={ref}
            name={name}
            maxLength={1000}
            aria-label={label}
            placeholder={placeholder}
            onFocus={onFocus}
            rows={rows}
            onChange={(value) => {
              onChange && onChange(value);
            }}
            className={classNames([
              "simple-input relative inline-flex w-full",
              // sizeMap[size],
              className,
            ])}
            {...props}
          />
        </div>
      </React.Fragment>
    );
  }
);
TextAreaInput.displayName = "TextAreaInput";
export { TextAreaInput };
